import projectPreview1 from '../assets/images/desktop/project-preview1.svg';
import projectIcon1 from '../assets/images/project-icon1.svg';
import projectTopImage1 from '../assets/images/desktop/project-top-image1.svg';
import gradient1 from '../assets/images/gradient-portfolio-card1.svg';

import projectPreview2 from '../assets/images/desktop/project-preview2.svg';
import projectIcon2 from '../assets/images/project-icon2.svg';
import projectTopImage2 from '../assets/images/desktop/project-top-image2.svg';
import gradient2 from '../assets/images/gradient-portfolio-card2.svg';

import projectPreview3 from '../assets/images/desktop/project-preview3.svg';
import projectIcon3 from '../assets/images/project-icon3.svg';
import projectTopImage3 from '../assets/images/desktop/project-top-image3.svg';
import gradient3 from '../assets/images/gradient-portfolio-card3.svg';

import projectPreview4 from '../assets/images/desktop/project-preview4.svg';
import projectIcon4 from '../assets/images/project-icon4.svg';
import projectTopImage4 from '../assets/images/desktop/project-top-image4.svg';
import gradient4 from '../assets/images/gradient-portfolio-card1.svg';

// 🔁 Mobile Versions
import projectPreview1Mobile from '../assets/images/mobile/project-preview1-mobile.svg';
import projectTopImage1Mobile from '../assets/images/mobile/project-top-image1-mobile.svg';

import projectPreview2Mobile from '../assets/images/mobile/project-preview2-mobile.svg';
import projectTopImage2Mobile from '../assets/images/mobile/project-top-image2-mobile.svg';

import projectPreview3Mobile from '../assets/images/mobile/project-preview3-mobile.svg';
import projectTopImage3Mobile from '../assets/images/mobile/project-top-image3-mobile.svg';

import projectPreview4Mobile from '../assets/images/mobile/project-preview4-mobile.svg';
import projectTopImage4Mobile from '../assets/images/mobile/project-top-image4-mobile.svg';

const isMobile = window.innerWidth <= 490;

const projects = [
  {
    id: 1,
    image: isMobile ? projectPreview1Mobile : projectPreview1,
    icon: projectIcon1,
    title: isMobile ? 'LocAlert' : 'LocAlert - iOS App',
    subtitle: 'iOS App',
    link: 'https://apps.apple.com/br/app/localert-disaster-tracker/id6469090077',
    topImage: isMobile ? projectTopImage1Mobile : projectTopImage1,
    topImageOffset: isMobile ? 'clamp(6.3rem, 10vh, 12rem)' : '1.2%',
    topImageHeight: isMobile ? 'clamp(20rem, 48vh, 21rem)' : undefined,
    gradientImage: gradient1,
  },
  {
    id: 2,
    image: isMobile ? projectPreview2Mobile : projectPreview2,
    icon: projectIcon2,
    title: isMobile ? 'Peregrinus' : 'Peregrinus - iOS App',
    subtitle: 'iOS App',
    link: 'https://apps.apple.com/br/app/peregrinus-jornada-cat%C3%B3lica/id6717613991',
    topImage: isMobile ? projectTopImage2Mobile : projectTopImage2,
    topImageOffset: isMobile ? 'clamp(8.2rem, 10vh, 12rem)' : 'clamp(2.5%, 38.5%, 20.5%)',
    topImageHeight: isMobile ? 'clamp(18rem, 40vh, 19rem)' : undefined,
    gradientImage: gradient2,
  },
  {
    id: 3,
    image: isMobile ? projectPreview3Mobile : projectPreview3,
    icon: projectIcon3,
    title: isMobile ? 'Vayoo': 'Vayoo - Startup',
    subtitle: 'Startup',
    link: '',
    topImage: isMobile ? projectTopImage3Mobile : projectTopImage3,
    topImageOffset: isMobile ? 'clamp(8.8rem, 14vh, 12rem)' : '26.5%',
    topImageHeight: isMobile ? 'clamp(15.8rem, 40vh, 16.2rem)' : undefined,
    gradientImage: gradient3,
  },
  {
    id: 4,
    image: isMobile ? projectPreview4Mobile : projectPreview4,
    icon: projectIcon4,
    title: isMobile ? 'Divisor' : 'Divisor - iOS App',
    subtitle: 'iOS App',
    link: 'https://apps.apple.com/us/app/divisor-formador-de-grupos/id6449653560',
    topImage: isMobile ? projectTopImage4Mobile : projectTopImage4,
    topImageOffset: isMobile ? 'clamp(8.2rem, 10vh, 12rem)' : '26.5%',
    topImageHeight: isMobile ? 'clamp(18rem, 40vh, 19rem)' : undefined,
    gradientImage: gradient4,
  },
];

export default projects;
